import { render, staticRenderFns } from "./RoHAnchorList.vue?vue&type=template&id=6f2ea427&scoped=true&"
import script from "./RoHAnchorList.vue?vue&type=script&lang=js&"
export * from "./RoHAnchorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ea427",
  null
  
)

export default component.exports